import * as RadixSelect from '@radix-ui/react-select'
import { FC } from 'react'
import { styled } from '../../../config'
import { Icons } from '../../../index'
import { scrollButtonStyles } from '../constants'

export interface SelectScrollDownButtonProps extends RadixSelect.SelectScrollDownButtonProps {}

const StyledSelectScrollDownButton = styled(RadixSelect.ScrollDownButton, scrollButtonStyles)

export const SelectScrollDownButton: FC<SelectScrollDownButtonProps> = (props) => {
  return (
    <StyledSelectScrollDownButton {...props}>
      <Icons.ChevronDown />
    </StyledSelectScrollDownButton>
  )
}
